<div class="card">
  <div class="card-body">
    <div class="row">
      <div class="form-group col-md-3">
        <label for="nome" class="control-label col-form-label" >Blocco:</label>
        <input [(ngModel)]="Blocco.nome" #nome="ngModel" placeholder="Testo" type="text" id="nome" class="form-control ">
        <small class="form-text text-danger" *ngIf="!nome.valid && (nome.dirty || nome.touched)">Campo richiesto!</small>
      </div>
      <div class="form-group col-md-3">
        <label for="marker" class="control-label col-form-label" >Marker:</label>
        <input [(ngModel)]="Blocco.marker" #marker="ngModel" placeholder="Testo" type="text" id="marker" class="form-control ">
        <small class="form-text text-danger" *ngIf="!marker.valid && (marker.dirty || marker.touched)">Campo richiesto!</small>
      </div>
      <div class="form-group col-md-3">
        <label for="nome" class="control-label col-form-label" >Sezione:</label>
        <ng-multiselect-dropdown  [settings]="DropdownSettings" [placeholder]="'Sezione'" [data]="Sezioni" [(ngModel)]="SezioneSelected" ></ng-multiselect-dropdown>
      </div>
    </div>
    <div class="d-flex justify-content-end">
      <button type="submit" (click)="saveClick()"  class=" btn btn-success p-2 waves-effect waves-light">
        <span class="ml-1 text-white font-weight-bold"> Salva </span>
        <i-feather name="save" class="feather-md "></i-feather>
      </button>
      <button type="submit" (click)="saveClick(true)"  class=" btn  btn-success p-2 waves-effect waves-light">
        <span class="ml-1 text-white font-weight-bold"> Salva e chiudi </span>
        <i-feather name="save" class="feather-md "></i-feather>
      </button>
    </div>
  </div>
</div>
<div class="card" *ngIf="Blocco?.id">
  <div class="card-body">
    <app-contenuti [(Blocco)]="Blocco" ></app-contenuti>
  </div>
</div>

